import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'duties-cost-calculator' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
